import React          from 'react';
import styled         from 'styled-components';
import { History }    from 'history';
import { Grid }       from '@material-ui/core';
import { AddBox }     from '@material-ui/icons';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import { EAppPage }   from '@enums/common';
import {
  ENationalAdPage,
  ENationalAdSubpage,
}                     from '@enums/nationalAdManagement';
import { Button }     from '@components/index';

interface IProps extends Pick<History, 'push'> {
  width    : Breakpoint;
  page     : ENationalAdPage;
  subpage? : ENationalAdSubpage;
}

const Wrapper = styled.div`
  background-color : ${({ theme: { backgroundColor } }): string => backgroundColor.white};
  padding          : 30px 20px 20px;

  @media (min-width: 600px) {
    padding: 40px 100px 20px;
  }
`;

const Navigation = styled.div`
  display        : flex;
  flex-direction : column;
  height         : 44px;
  margin-left    : 30px;
  transition     : .6ms ease;

  @media (min-width: 600px) {
    flex-direction : row;
    margin-left    : 0;
  }
`;

const NavLink = styled.h1`
  ${({ isActive }: any): false | string => isActive && 'text-decoration: underline'};
  margin-right  : 50px;
  margin-bottom : 20px;

  ${({ pointer }: any): string => `cursor: ${pointer || 'pointer'}`};

  @media (min-width: 600px) {
    margin-bottom: 0;
  }
` as any;

export const TopComponent: React.FC<IProps> = ({
  push,
  width,
  page,
  subpage,
}) => (
  <Wrapper>
    <Grid container justify="space-between" alignItems="center">
      <Grid item>
        <Navigation>
          {(page === ENationalAdPage.cards && !subpage) && (
            <>
              <NavLink
                isActive = {page === ENationalAdPage.cards}
                onClick  = {(): void => push(`${EAppPage.NationalAdManager}/${ENationalAdPage.cards}`)}
              >
                Card Ads
              </NavLink>
              <NavLink
                // isActive = {page === PAGE.banner}
                onClick  = {(): void => push(`${EAppPage.NationalAdManager}/${ENationalAdPage.banner}`)}
              >
                Banner Ad
              </NavLink>
            </>
          )}
          {(page === ENationalAdPage.cards && subpage === ENationalAdSubpage.add) && (
            <NavLink pointer="default">Add New Ad</NavLink>
          )}
          {(page === ENationalAdPage.cards && subpage === ENationalAdSubpage.edit) && (
            <NavLink pointer="default">Edit Existing Ad</NavLink>
          )}
          {page === ENationalAdPage.banner && <NavLink>Edit Banner</NavLink>}
        </Navigation>
      </Grid>

      {(page === ENationalAdPage.cards && !subpage) && (
        <Grid item xs={12} sm="auto">
          <Button
            aria-label = "Add New"
            onClick    = {(): void => push(`${EAppPage.NationalAdManager}/${ENationalAdPage.cards}/new/${ENationalAdSubpage.add}`)}
            margin     = "0"
            width      = "200px"
            fullWidth  = {width === 'xs'}
          >
            <AddBox />
            Add New Ad
          </Button>
        </Grid>
      )}
    </Grid>
  </Wrapper>
);
